import { ErrorBoundary } from "error/ErrorBoundary";
import AdminDashboard from "features/AdminDashboard/pages/AdminDashboard";
import { LoginWithMicrosoft } from "features/Authentication/LoginWithMicrosoft";
import RequireAuth, { RequireAdmin } from "features/Authentication/RequireAuth";
import UnauthorizedPage from "features/Authentication/UnauthorizedPage";
import Calendar from "features/Calendar/pages/Calendar";
import Dashboard from "features/Dashboard/pages/Dashboard";
import { GenerateOTP } from "features/GenerateOTP/GenerateOTP";
import { IncomingSamples } from "features/IncomingSamples/pages/IncomingSamples";
import { MethodManager } from "features/MethodManager/pages/MethodManager";
import { PageWithNav } from "features/Navbar/PageWithNav";
import { PersonalTaskTemplatePage } from "features/PersonalTasks/components/PersonalTaskTemplate/pages/PersonalTaskTemplate";
import { Plates } from "features/Plates/pages/Plates";
import { Samples } from "features/Samples/pages/Samples";
import { TeamGantt } from "features/TeamGantt/pages/TeamGantt";
import { Tickets } from "features/Tickets/pages/Tickets";
import { TubeLabeller } from "features/TubeLabeller/pages/TubeLabeller";
import { AccountSettings } from "features/UserSettings/Settings";
import { WorklistLandingPage } from "features/WorklistTools/pages/WorklistLandingPage";
import { WorklistTool } from "features/WorklistTools/pages/WorklistTool";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, RouteProps, Switch } from "react-router-dom";
import Loading from "shared-components/Loading";

const RunTemplate = lazy(() =>
  import("features/RunTemplate/pages/RunTemplate").then((module) => ({
    default: module.RunTemplate,
  })),
);

const Runs = lazy(() =>
  import("features/Runs/pages/Runs").then((module) => ({
    default: module.Runs,
  })),
);

export function RouteWithErrorBoundary(props: RouteProps) {
  return (
    <ErrorBoundary>
      <Route {...props} />
    </ErrorBoundary>
  );
}
export function AppRoutes(): JSX.Element {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <PageWithNav>
            <Loading name="rotating-plane" color="red" />
          </PageWithNav>
        }
      >
        <Switch>
          <RouteWithErrorBoundary path="/login">
            <LoginWithMicrosoft />
          </RouteWithErrorBoundary>
          <RequireAuth path="/">
            <Route exact path="/">
              <Dashboard />
            </Route>
            <Route path="/generate-otp">
              <GenerateOTP />
            </Route>
            <Route path="/account-settings">
              <AccountSettings />
            </Route>
            <Route path="/personal-task-template">
              <PersonalTaskTemplatePage />
            </Route>
            <Route path="/tickets">
              <Tickets />
            </Route>
            <Route path="/incoming-samples">
              <IncomingSamples />
            </Route>
            <Route exact path="/worklist-tools">
              <WorklistLandingPage />
            </Route>
            <Route path="/worklist-tools/:methodId">
              <WorklistTool />
            </Route>
            <Route path="/tube-labeller">
              <TubeLabeller />
            </Route>
            <Route path="/runs">
              <Runs />
            </Route>
            <Route path="/run-templates">
              <RunTemplate />
            </Route>
            <Route path="/method-manager">
              <MethodManager />
            </Route>
            <Route path="/calendar">
              <Calendar />
            </Route>
            <Route path="/gantt">
              <TeamGantt />
            </Route>
            <Route path="/samples">
              <Samples />
            </Route>
            <Route path="/plates">
              <Plates />
            </Route>
            <Route path="/admin-dashboard">
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            </Route>
            <Route path="/unauthorized">
              <UnauthorizedPage />
            </Route>
          </RequireAuth>
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}
